import { useEffect } from 'react';

export const useLayoutEffect = (shiftLeftActive, isMobileView) => {
  // Effect to monitor search results visibility and ensure proper overflow settings
  useEffect(() => {
    // Add class to body when component mounts
    document.body.classList.add('hide-header');
    
    // Manage scrolling behavior based on search results visibility
    if (shiftLeftActive && isMobileView) {
      // When search results are shown on mobile, ensure scrolling is possible
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
      document.body.style.position = 'static';
      document.body.style.height = 'auto';
      document.documentElement.style.height = 'auto';
      
      // Add iOS Safari specific fixes
      document.body.style.webkitOverflowScrolling = 'touch';
      document.documentElement.style.webkitOverflowScrolling = 'touch';
    }
    
    return () => {
      // Clean up when component unmounts or effect dependencies change
      document.body.classList.remove('hide-header');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.style.position = '';
      document.body.style.height = '';
      document.documentElement.style.height = '';
      document.body.style.webkitOverflowScrolling = '';
      document.documentElement.style.webkitOverflowScrolling = '';
    };
  }, [shiftLeftActive, isMobileView]);
}; 